import React, { useState } from 'react';
import { Accordion } from './ui/Accordion';
export function TCOComfort() {
  const [energyPrice, setEnergyPrice] = useState(2.5);
  const [insulation, setInsulation] = useState('medium');
  const [operatingHours, setOperatingHours] = useState(1800);
  const [setPoint, setSetPoint] = useState(21);
  // Sample data for the four options
  const options = [{
    type: 'mix',
    title: 'DIT MIX',
    badge: 'Din nuværende sammensætning',
    price: 189500,
    monthlyPayment: 1249,
    eta: '5-7 hverdage',
    comfort: 'forbedret',
    investmentCost: 189500,
    annualOperation: 8500,
    kwhPerYear: 3400,
    co2PerYear: 850,
    paybackYears: 6.2
  }, {
    type: 'good',
    title: 'GOOD',
    badge: 'Laveste pris',
    price: 169900,
    monthlyPayment: 1099,
    eta: '2-3 uger',
    comfort: 'standard',
    investmentCost: 169900,
    annualOperation: 9800,
    kwhPerYear: 3920,
    co2PerYear: 980,
    paybackYears: 8.5
  }, {
    type: 'better',
    title: 'BETTER',
    badge: 'Balance',
    price: 189500,
    monthlyPayment: 1249,
    eta: '5-7 hverdage',
    comfort: 'forbedret',
    investmentCost: 189500,
    annualOperation: 8500,
    kwhPerYear: 3400,
    co2PerYear: 850,
    paybackYears: 6.2
  }, {
    type: 'best',
    title: 'BEST',
    badge: 'Højeste komfort',
    price: 219900,
    monthlyPayment: 1499,
    eta: '1-2 uger',
    comfort: 'høj jævnhed',
    investmentCost: 219900,
    annualOperation: 7200,
    kwhPerYear: 2880,
    co2PerYear: 720,
    paybackYears: 5.1
  }];
  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('da-DK', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount) + ' kr';
  };
  // Get comfort indicator color
  const getComfortColor = (comfort: string) => {
    switch (comfort) {
      case 'standard':
        return 'text-blue-600';
      case 'forbedret':
        return 'text-green-600';
      case 'høj jævnhed':
        return 'text-purple-600';
      default:
        return 'text-gray-600';
    }
  };
  return <Accordion title="TCO & Komfort" data-id="element-170">
      <div className="space-y-6" data-id="element-171">
        {/* Option cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-172">
          {options.map(option => <div key={option.type} className={`bg-white rounded-2xl shadow-sm border p-4 ${option.type === 'mix' ? 'border-red-200' : 'border-gray-200'}`} data-id="element-173">
              <div className="mb-3" data-id="element-174">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-175">
                  {option.title}
                </h3>
                <div className={`text-xs mt-1 inline-block px-2 py-0.5 rounded-full ${option.type === 'mix' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-176">
                  {option.badge}
                </div>
              </div>
              <div className="space-y-3" data-id="element-177">
                <div data-id="element-178">
                  <div className="text-2xl font-medium text-gray-900" data-id="element-179">
                    {formatCurrency(option.price)}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-180">
                    fra {option.monthlyPayment} kr/md
                  </div>
                </div>
                <div className="flex items-center" data-id="element-181">
                  <div className="text-sm text-gray-700" data-id="element-182">ETA: {option.eta}</div>
                </div>
                <div className="flex items-center" data-id="element-183">
                  <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-184">
                    <div className={`h-2 rounded-full ${option.comfort === 'standard' ? 'bg-blue-500 w-1/3' : option.comfort === 'forbedret' ? 'bg-green-500 w-2/3' : 'bg-purple-500 w-full'}`} data-id="element-185"></div>
                  </div>
                  <div className={`ml-2 text-sm ${getComfortColor(option.comfort)}`} data-id="element-186">
                    {option.comfort}
                  </div>
                </div>
                {/* Mini TCO diagram */}
                <div className="pt-2" data-id="element-187">
                  <div className="text-xs text-gray-500 mb-1" data-id="element-188">5-års TCO</div>
                  <div className="flex h-8 items-end" data-id="element-189">
                    <div className="bg-gray-300 w-1/2" style={{
                  height: `${option.investmentCost / 250000 * 100}%`
                }} data-id="element-190"></div>
                    <div className="bg-blue-300 w-1/2" style={{
                  height: `${option.annualOperation * 5 / 60000 * 100}%`
                }} data-id="element-191"></div>
                  </div>
                  <div className="flex text-xs text-gray-500 mt-1" data-id="element-192">
                    <div className="w-1/2" data-id="element-193">Investering</div>
                    <div className="w-1/2" data-id="element-194">5 års drift</div>
                  </div>
                </div>
                {/* KPIs */}
                <div className="grid grid-cols-3 gap-2 pt-2" data-id="element-195">
                  <div className="text-center" data-id="element-196">
                    <div className="text-xs text-gray-500" data-id="element-197">Payback</div>
                    <div className="text-sm font-medium" data-id="element-198">
                      {option.paybackYears} år
                    </div>
                  </div>
                  <div className="text-center" data-id="element-199">
                    <div className="text-xs text-gray-500" data-id="element-200">Årlig kWh</div>
                    <div className="text-sm font-medium" data-id="element-201">
                      {option.kwhPerYear}
                    </div>
                  </div>
                  <div className="text-center" data-id="element-202">
                    <div className="text-xs text-gray-500" data-id="element-203">CO₂</div>
                    <div className="text-sm font-medium" data-id="element-204">
                      {option.co2PerYear} kg/år
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* Control panel */}
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-205">
          <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-206">
            Beregningsparametre
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-207">
            <div data-id="element-208">
              <div className="flex justify-between mb-1" data-id="element-209">
                <label className="text-xs text-gray-600" data-id="element-210">
                  Energipris (kr/kWh): {energyPrice.toFixed(1)}
                </label>
                <span className="text-xs text-gray-600" data-id="element-211">
                  {energyPrice.toFixed(1)}
                </span>
              </div>
              <input type="range" min="1" max="5" step="0.1" value={energyPrice} onChange={e => setEnergyPrice(parseFloat(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-212" />
            </div>
            <div data-id="element-213">
              <div className="mb-1" data-id="element-214">
                <label className="text-xs text-gray-600" data-id="element-215">Isolering</label>
              </div>
              <div className="flex gap-2" data-id="element-216">
                <button className={`px-3 py-1 text-xs rounded-lg ${insulation === 'high' ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} onClick={() => setInsulation('high')} data-id="element-217">
                  God
                </button>
                <button className={`px-3 py-1 text-xs rounded-lg ${insulation === 'medium' ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} onClick={() => setInsulation('medium')} data-id="element-218">
                  Middel
                </button>
                <button className={`px-3 py-1 text-xs rounded-lg ${insulation === 'low' ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} onClick={() => setInsulation('low')} data-id="element-219">
                  Lav
                </button>
              </div>
            </div>
            <div data-id="element-220">
              <div className="flex justify-between mb-1" data-id="element-221">
                <label className="text-xs text-gray-600" data-id="element-222">
                  Driftstimer: {operatingHours}
                </label>
                <span className="text-xs text-gray-600" data-id="element-223">{operatingHours}</span>
              </div>
              <input type="range" min="1000" max="3000" step="100" value={operatingHours} onChange={e => setOperatingHours(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-224" />
            </div>
            <div data-id="element-225">
              <div className="flex justify-between mb-1" data-id="element-226">
                <label className="text-xs text-gray-600" data-id="element-227">
                  Setpunkt (°C): {setPoint}
                </label>
                <span className="text-xs text-gray-600" data-id="element-228">{setPoint}</span>
              </div>
              <input type="range" min="18" max="24" value={setPoint} onChange={e => setSetPoint(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-229" />
            </div>
          </div>
        </div>
      </div>
    </Accordion>;
}